export default __webpack_public_path__ + "static/media/11.aed1f153.jpg";